/**
 * @returns {string|undefined}
 */
function stateId (project = 'cl') {
  return `__${project}_STATE__`
    .replace(/-/g, '_')
    .toUpperCase()
}

module.exports = { stateId }
